var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroStar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.725,
    height: 60.728,
    viewBox: "0 0 60.725 60.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M59.13,32.66C44.044,38.152,38.149,44.042,32.657,59.132a2.446,2.446,0,0,1-4.588,0C22.578,44.042,16.683,38.152,1.6,32.66a2.446,2.446,0,0,1,0-4.588C16.683,22.58,22.578,16.685,28.07,1.6a2.445,2.445,0,0,1,4.588,0C38.149,16.685,44.044,22.58,59.13,28.072a2.446,2.446,0,0,1,0,4.588",
    transform: "translate(-0.001)",
    fill: "#f3f1e4",
    opacity: 0.205
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroStar1);
export default __webpack_public_path__ + "static/media/hero-star-1.5f4d2e6526e21b964610131a6dbfa820.svg";
export { ForwardRef as ReactComponent };